import React, { useState } from 'react';
import Quote from './Quote.jsx';
import './Quote.css';

export default function QuoteWrapper(props) {
  const [resetKey, setResetKey] = useState(0);

  const handleReset = () => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem('cap_quote_state');
      window.sessionStorage.removeItem('cap_pending_order');
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    setResetKey(prev => prev + 1);
  };

  return <Quote key={resetKey} onResetFlow={handleReset} {...props} />;
}
